module.exports = __webpack_public_path__ + "media/icons/tie-gray-72bdfaa3.png";